/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Nav_OrganizationsInputs */

const da_admin_nav_organizations = /** @type {(inputs: Admin_Nav_OrganizationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organisationer`)
};

/** @type {(inputs: Admin_Nav_OrganizationsInputs) => LocalizedString} */
const en_admin_nav_organizations = da_admin_nav_organizations;

/**

* @param {Admin_Nav_OrganizationsInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const admin_nav_organizations = /** @type {((inputs?: Admin_Nav_OrganizationsInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Nav_OrganizationsInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_nav_organizations(inputs)
	return /** @type {LocalizedString} */ ("Organisationer")
});